import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type { FoundationAssemblyEntity } from "building-types/foundations/foundationAssemblyEntityTypes";
import type { FoundationSubSystemType } from "building-types/foundations/foundationEnums";
import type { ForeignEntityId } from "building-types/handles/foreignEntityId";
import uid from "common/utils/uid";

export function foundationAssemblyNewEntity(
  name: string,
  assemblySystem: FoundationSubSystemType,
  footingId?: ForeignEntityId<"FOUNDATION_COMPONENT">,
  stemWallId?: ForeignEntityId<"FOUNDATION_COMPONENT">,
  pierId?: ForeignEntityId<"FOUNDATION_COMPONENT">,
  id: string = uid(),
  sortIndex: number = 0,
): FoundationAssemblyEntity {
  return {
    ...docEntityBaseNew("FOUNDATION_ASSEMBLY", id),
    name,
    assemblySystem,
    footingId,
    stemWallId,
    pierId,
    sortIndex,
  };
}
